import React from 'react';

class Colors extends React.Component {
	constructor(props) {
		super(props);

		this.Interpolate = this.Interpolate.bind(this);
		this.Gradient = this.Gradient.bind(this);
	}

	Interpolate(color1, color2, factor) {
		if (arguments.length < 3)
			factor = 0.5;

		let result = color1.slice();

		for (let i = 0; i < 3; i++)
			result[i] = Math.round(result[i] + factor * (color2[i] - color1[i]));

		return result;
	};

	Gradient(color1, color2, steps) {
		const stepFactor = 1 / (steps - 1);
		let colors = [];

		color1 = color1.match(/\d+/g).map(Number);
		color2 = color2.match(/\d+/g).map(Number);

		for (let i = 0; i < steps; i++)
			colors.push(this.Interpolate(color1, color2, stepFactor * i));

		return colors;
	}
}

export default Colors;